import { AppParamsEffects } from './app-params.effects';


export const effects: any[] = [ AppParamsEffects];
